import { Icon, IconProps } from './Icon';

export const EditIcon = ({ color = 'currentColor', ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 20 20"
  >
    <path
      d="M14.6164 8.43379L11.5664 5.38379"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.20917 17.4999H2.5V14.7908C2.5 14.5699 2.5875 14.3574 2.74417 14.2016L13.8558 3.0891C14.1817 2.76327 14.7092 2.76327 15.0342 3.0891L16.91 4.96493C17.2358 5.29077 17.2358 5.81827 16.91 6.14327L5.79833 17.2558C5.6425 17.4124 5.43 17.4999 5.20917 17.4999V17.4999Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
